import {useContext, useEffect, useState} from "react";
import './flight.css';
import { useNavigate } from "react-router";
import { PaymentContext } from "../Payments/PaymentContext";
import {
    Button,
    Typography
} from '@mui/material'

export default function BookFlights(){
    const [dataObtained, setDataObtained] = useState([]);
    const [date, setDate] = useState(new Date());
    const navigate = useNavigate();
    const { setSurcharge, setPrice } = useContext(PaymentContext);
    const [loader, setLoader] = useState(true);


    useEffect(()=>{
        window.scrollTo(0, 0)
        const url = 'https://content.newtonschool.co/v1/pr/63b85b1209f0a79e89e17e3a/flights';
        fetch(url)
    .then((res)=>{
        res.json()
        .then((data)=>{
            setDataObtained(data);
            setLoader(false);
        })
    })
    } , [])
    
    return (
       <>
       {/* <img src="https://cdn.dribbble.com/users/967990/screenshots/2706145/letadlo_dribbble.gif" style={{width:"1000px", height:'200px',display:'block', margin:'10px auto'}}  /> */}
        {loader ? <div className="loader">
            <img src="/loader.gif" style={{width:'100px', height:'100px'}}></img>
        </div> : 
        
        <>
            <h3 style={{position:'absolute', left:'16vw', marginTop:'20px'}}>Available Tickets</h3>
        <div className="ticket-container1">
            {dataObtained.map((el, idx)=>{
                return (
                    <div className="tkt-box1" key={idx}>
                        <table>
                            <tr>
                                <td>From</td>
                                <td>DEPARTURE</td>
                                <td>PRICE</td>
                            </tr>
                            <tr>
                                <td><Typography 
                                variant='h4'
                                sx={{lineHeight:'0.5'}}
                                >{el.from}</Typography></td>
                                <td><h4>{el.departure.departureTime}|{date.getDate()}-{date.getMonth()}-{date.getFullYear()}</h4></td>
                                <td>{el.price}</td>
                            </tr>
                            <tr>
                                <td>To</td>
                                <td>RETURN</td>
                                <td>VIA</td>
                            </tr>
                            <tr>
                                <td><Typography 
                                variant='h4' 
                                sx={{lineHeight:'0.5'}}
                                >{el.to}</Typography></td>
                                <td><h4>{el.return.returnTime}|{date.getDate()}-{date.getMonth()}-{date.getFullYear()}</h4></td>
                                <td>{el.via.length ? el.via[0] : "N/A"}</td>
                            </tr>
                            <tr>
                                <td>Airline:</td>
                                <td>Duration:</td>
                            </tr>
                            <tr>
                                <td><h4>{el.airlineName}</h4></td>
                                <td><h4>{el.duration}</h4></td>
                            </tr>
                        </table>
                        <Button
                        sx={{float:'right', marginRight:'20px', marginBottom:'20px'}}
                        id={el.price} 
                        variant="contained"
                        onClick={ (e)=>{
                            e.persist();
                            console.log(e.currentTarget.id);
                            setPrice(parseInt(e.currentTarget.id));
                            setSurcharge(parseInt(e.currentTarget.id)*0.15);
                            navigate('/payments');
                        }
                        }>BOOK</Button>
                    </div>
                )
            })}
        </div>
        </> }
       </> 
    )
}